import { Smartphone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LANDING } from "@/constants/landingTestIds";

const FinalCta = () => {
  return (
    <section id="download" className="bg-white py-24 sm:py-28">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="relative rounded-3xl bg-[#0F172A] px-8 py-16 sm:px-16 sm:py-20 text-center overflow-hidden">
          <div className="absolute -top-24 left-1/4 w-72 h-72 bg-[#2563EB]/30 rounded-full blur-[110px]" />
          <div className="absolute -bottom-24 right-1/4 w-72 h-72 bg-[#14b8a6]/20 rounded-full blur-[110px]" />

          <div className="relative">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white max-w-2xl mx-auto">
              Ready to grow your real estate business 10x?
            </h2>
            <p className="mt-5 text-base sm:text-lg text-slate-300 max-w-xl mx-auto">
              Join modern agents, brokers & consultants who've ditched the paper diary for
              Tracre One.
            </p>
            <Button
              data-testid={LANDING.ctaDownloadBtn}
              size="lg"
              onClick={() => window.open("#", "_blank", "noopener,noreferrer")}
              className="mt-10 bg-[#2563EB] hover:bg-[#1D4ED8] text-white rounded-lg h-14 px-9 text-base font-semibold shadow-lg shadow-blue-500/30 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300 gap-2.5"
            >
              <Smartphone className="w-5 h-5" />
              Download Android App
              <ArrowRight className="w-4 h-4" />
            </Button>
            <p className="mt-4 text-xs text-slate-500">Free to get started. No credit card required.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
